import { render, staticRenderFns } from "./StopwatchView.vue?vue&type=template&id=6152f95e&scoped=true"
import script from "./StopwatchView.vue?vue&type=script&lang=js"
export * from "./StopwatchView.vue?vue&type=script&lang=js"
import style0 from "./StopwatchView.vue?vue&type=style&index=0&id=6152f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152f95e",
  null
  
)

export default component.exports